import { CONFIGURATOR_ID, SUBFAMILY_ID } from '@/constants/ui.constants'
import { action, createRequestTypes } from '@/utils/actions.utils'
import { errorActions } from '@/redux/actions'
import { userService } from '@/services'
import Toggles from '@domain/toggles/Toggles'

export const NAVIGATE_TO = 'NAVIGATE_TO'
const navigateTo = ({ path, requiredUserStatus = null, state = {} }) => {
	return action(NAVIGATE_TO, { path, requiredUserStatus, state })
}

export const NAVIGATE_TO_CONFIGURATOR = 'NAVIGATE_TO_CONFIGURATOR'
const navigateToConfigurator = ({ configuratorType, preconfigId, projectId, state, subFamilyId }) => {

	return (dispatch) => {
		const projectUrlPart = projectId ? `/project/${projectId}/add-product` : '/new-product'
		const preconfigIdUrlPart = preconfigId ? `?preconfigId=${preconfigId}` : ''

		switch (configuratorType.id) {
			case CONFIGURATOR_ID.CREA:
				return dispatch(
					action(NAVIGATE_TO, {
						path: `${projectUrlPart}/crea-configurator${preconfigIdUrlPart}`,
						state
					})
				)
			case CONFIGURATOR_ID.DRAWING:
				switch (subFamilyId) {
					case SUBFAMILY_ID.PLUSMINUS:
						return dispatch(
							action(NAVIGATE_TO, {
								path: `${projectUrlPart}/plusminus-drawing-configurator${preconfigIdUrlPart}`,
								state
							})
						)
					case SUBFAMILY_ID.STICKS:
						return dispatch(
							action(NAVIGATE_TO, {
								path: `${projectUrlPart}/sticks-drawing-configurator${preconfigIdUrlPart}`,
								state
							})
						)
					default:
						throw 'SubfamilyId does not match any drawing configurator'
				}
			case CONFIGURATOR_ID.NODRAWING:
				switch (subFamilyId) {
					case SUBFAMILY_ID.PLUSMINUS:
						return dispatch(
							action(NAVIGATE_TO, {
								path: `${projectUrlPart}/plusminus-nodrawing-configurator`,
								state
							})
						)
					case SUBFAMILY_ID.STICKS:
						return dispatch(
							action(NAVIGATE_TO, {
								path: `${projectUrlPart}/sticks-nodrawing-configurator`,
								state
							})
						)
					default:
						throw 'SubfamilyId does not match any not-drawing configurator'
				}
			default:
				dispatch(errorActions.setError('No configurator setted!'))
		}
	}
}

export const NAVIGATION_END = 'NAVIGATION_END'
const navigationEnd = () => {
	return action(NAVIGATION_END)
}

export const SET_NAVIGATION = 'SET_NAVIGATION'
const setNavigation = (payload) => {
	return action(SET_NAVIGATION, payload)
}

export const SET_ACTION_DONE = 'SET_ACTION_DONE'
const setActionDone = (actionDone) => {
	return (dispatch) => {
		dispatch(action(SET_ACTION_DONE, actionDone))
		return dispatch(resetActionDone())
	}
}

export const RESET_ACTION_DONE = 'RESET_ACTION_DONE'
const resetActionDone = () => {
	return action(RESET_ACTION_DONE)
}

export const GET_USER_CONFIGURATIONS_BY_SITE_LOCATION = createRequestTypes('GET_USER_CONFIGURATIONS_BY_SITE_LOCATION')
const userConfigurationsBySiteLocation = (siteLocation) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ siteLocation }))
			const res = await userService.userConfigurationsBySiteLocation(siteLocation)
			let userButtons = res.data.BUTTONS;

			if (Toggles.isEnabled('hideCloneProject')) {
				Object.keys(userButtons).forEach(category => {
					userButtons[category] = userButtons[category].filter(button => button.key !== 'button.project.duplicate');
				});
			}

			return dispatch(success({ siteLocation, userButtons: res.data }))
		} catch (error) {
			return dispatch(failure(error, { siteLocation }))
		}
	}

	function request() {
		return action(GET_USER_CONFIGURATIONS_BY_SITE_LOCATION.REQUEST, { siteLocation })
	}
	function success(payload) {
		return action(GET_USER_CONFIGURATIONS_BY_SITE_LOCATION.SUCCESS, payload)
	}
	function failure(error, payload) {
		return action(GET_USER_CONFIGURATIONS_BY_SITE_LOCATION.FAILURE, payload, error)
	}
}

export const FETCH_SUBMENU = createRequestTypes('FETCH_SUBMENU')
const fetchSubmenuLinks = ({ catalogId, role }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())
			const res = await userService.fetchSubmenuLinks({ catalogId, role })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request(payload) {
		return action(FETCH_SUBMENU.REQUEST, payload)
	}
	function success(payload) {
		return action(FETCH_SUBMENU.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_SUBMENU.FAILURE, null, err)
	}
}

export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'
const dismissNotification = (notificationId) => {
	return action(HIDE_NOTIFICATION, notificationId)
}

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
const showNotification = (notificationId) => {
	return action(SHOW_NOTIFICATION, notificationId)
}

export const COLLECTION_VIEW = 'COLLECTION_VIEW'
const collectionView = (payload) => {
	return action(COLLECTION_VIEW, payload)
}

export default {
	navigateTo,
	navigateToConfigurator,
	navigationEnd,
	setNavigation,
	setActionDone,
	resetActionDone,
	userConfigurationsBySiteLocation,
	fetchSubmenuLinks,
	dismissNotification,
	showNotification,
	collectionView
}
